import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import { persistConfig } from 'store/persistConfig';
import adminSessionReducer from 'store/slices/adminSessionSlice';
import authReducer from 'store/slices/authSlice';
import flowReducer from 'store/slices/flowSlice';
import orgOnboardingReducer from 'store/slices/orgOnboardingSlice';
import payrollReducer from 'store/slices/payrollSlice';
import planReducer from 'store/slices/planSlice';
import postLoginRedirectReducer from 'store/slices/postLoginRedirectSlice';
import userSessionReducer from 'store/slices/userSessionSlice';

import { hydrateStoreFromTabSession } from '../services/auth/sessionTokenTabStorage';

const rootReducer = combineReducers({
  auth: authReducer,
  adminSession: adminSessionReducer,
  userSession: userSessionReducer,
  payroll: payrollReducer,
  plan: planReducer,
  flow: flowReducer,
  orgOnboarding: orgOnboardingReducer,
  postLoginRedirect: postLoginRedirectReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: { ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'] },
    }),
});

export const persistor = persistStore(store, null, () => {
  // Restore tab tokens after persist rehydrate so session slices are not left empty on refresh.
  hydrateStoreFromTabSession(store.dispatch);
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
